/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Enrich_Manage_HintInputs */

const en_directory_submit_enrich_manage_hint = /** @type {(inputs: Directory_Submit_Enrich_Manage_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You can edit or manage it anytime in My Tools.`)
};

const zh_directory_submit_enrich_manage_hint = /** @type {(inputs: Directory_Submit_Enrich_Manage_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你可以随时在“我的工具”中编辑和管理它。`)
};

/**
* | output |
* | --- |
* | "You can edit or manage it anytime in My Tools." |
*
* @param {Directory_Submit_Enrich_Manage_HintInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_enrich_manage_hint = /** @type {((inputs?: Directory_Submit_Enrich_Manage_HintInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Enrich_Manage_HintInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_enrich_manage_hint(inputs)
	return zh_directory_submit_enrich_manage_hint(inputs)
});
export { directory_submit_enrich_manage_hint as "directory.submit.enrich.manage_hint" }